(function(){
  var $=function(s,r){return (r||document).querySelector(s)};
  var head=$('#head'), isHome=document.body.classList.contains('tpl-index');
  function solid(){head.classList.toggle('solid',window.scrollY>40||!isHome)}
  window.addEventListener('scroll',solid,{passive:true}); solid();
  function setHH(){document.documentElement.style.setProperty('--hh',head.offsetHeight+'px')}
  if(!isHome){setHH();window.addEventListener('resize',setHH)}
  var toastEl=$('#toast');
  function toast(m){toastEl.textContent=m;toastEl.classList.add('on');clearTimeout(toast.h);toast.h=setTimeout(function(){toastEl.classList.remove('on')},2400)}
  /* Carrousel */
  (function(){
    var t=$('#car-track'); if(!t) return;
    function step(d){t.scrollBy({left:d*(t.querySelector('.slide').offsetWidth+14),behavior:'smooth'})}
    var pv=$('#car-prev'),nx=$('#car-next');
    var paused=false,resume;
    function hold(){paused=true;clearTimeout(resume);resume=setTimeout(function(){paused=false},6000)}
    pv.addEventListener('click',function(){step(-1);hold()});nx.addEventListener('click',function(){step(1);hold()});
    ['pointerdown','wheel','touchstart','click'].forEach(function(e){t.addEventListener(e,hold,{passive:true})});
    t.addEventListener('mouseenter',function(){paused=true;clearTimeout(resume)});
    t.addEventListener('mouseleave',function(){paused=false});
    var vis=false;
    if('IntersectionObserver' in window)new IntersectionObserver(function(en){vis=en[0].isIntersecting}).observe(t);else vis=true;
    if(!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches))setInterval(function(){
      if(paused||!vis||!t.offsetWidth)return;
      var w=t.querySelector('.slide').offsetWidth+14;
      if(t.scrollLeft+t.clientWidth>=t.scrollWidth-8)t.scrollTo({left:0,behavior:'smooth'});else t.scrollBy({left:w,behavior:'smooth'});
    },3000);
  })();
  /* Fiche produit */
  (function(){
    var form=$('#pdp-form'),data=$('#pdp-data'); if(!form||!data) return;
    var V=JSON.parse(data.textContent),idIn=$('input[name=id]',form),price=$('#pdp-price'),add=$('#add'),wa=$('#wa-order');
    var groups=[].slice.call(document.querySelectorAll('.chips[data-opt]'));
    var sel=groups.map(function(g){var c=g.querySelector('.chip[aria-pressed=true]');return c?c.getAttribute('data-val'):null});
    var single=groups.length===1;
    function cur(){return V.filter(function(v){return v.o.every(function(x,i){return x===sel[i]})})[0]}
    function label(){var g=groups.map(function(g,i){var c=g.querySelector('.chip[aria-pressed=true]');return c?c.textContent:''}).join(', ');return $('#pdp-name').textContent+(g?' ('+g+')':'')}
    function upd(){
      var v=cur(); if(!v) return;
      idIn.value=v.id; price.textContent=v.p;
      add.disabled=!v.a; add.textContent=v.a?'Ajouter au panier':'Épuisé';
      wa.href='https://wa.me/2347044934956?text='+encodeURIComponent('Bonjour, je souhaite commander : '+label());
    }
    groups.forEach(function(g,i){
      [].forEach.call(g.querySelectorAll('.chip'),function(c){
        c.addEventListener('click',function(){
          sel[i]=c.getAttribute('data-val');
          [].forEach.call(g.querySelectorAll('.chip'),function(n){n.setAttribute('aria-pressed',n===c?'true':'false')});
          upd();
        });
      });
    });
    upd();
    form.addEventListener('submit',function(e){
      if(!window.fetch) return;
      e.preventDefault(); add.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){if(!r.ok)throw 0;return r.json()})
        .then(function(){return fetch('/cart.js').then(function(r){return r.json()})})
        .then(function(c){var n=$('#count');if(n)n.textContent=c.item_count;toast(label()+' : ajouté au panier');add.disabled=false})
        .catch(function(){form.submit()});
    });
  })();
})();
